'use client';
import { useId } from 'react';
import { VpLoader } from '@vtmn-play/logic';
import '../../utils/VpPoly.mjs';
import { normalizeProps } from '../../utils/normalize-props.mjs';

const useVpLoader = (props) => {
  const fallbackId = useId();
  const { logicProps, spreadableProps } = VpLoader.props(props, fallbackId);
  const api = VpLoader.connect(logicProps, normalizeProps);
  return { api, spreadableProps };
};

export { useVpLoader };
